import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  template: `<p-toast position="top-right" /><router-outlet />`,
  styles: [':host { display: block; height: 100vh; }'],
})
export class App {}
